"use client";

import { CartIcon } from "@/components/icons/CartIcon";
import Button from "@/components/ui/Button";
import navBarStyles from "@/components/ui/Navbar/index.module.css";
import { useTranslations } from "@/i18n/client";
import { useCart } from "@/lib/centra/hooks";

const CartToggle = () => {
  const t = useTranslations();
  const { data } = useCart();

  const quantity = data?.items?.reduce((acc, item) => {
    return acc + (item.quantity ?? 0);
  }, 0);

  return (
    <Button mode="unset" modal={"cart"} className={navBarStyles.navbarLinks}>
      <p className={navBarStyles.linksDesktop}>
        {t("megaMenu.cart")}
        {!!quantity && <>({quantity})</>}
      </p>
      <span className={navBarStyles.linksMobile}>
        <CartIcon />
      </span>
    </Button>
  );
};

export default CartToggle;
